// extracted by mini-css-extract-plugin
export default {"main-container":"IndividualList_main-container__40+Mg"};